import type { ToastProps } from "../types";

/**
 * Display a toast notification
 * @param props Toast notification properties
 */
export const toast = (props: ToastProps) => {
  const { title, description, severity = "info" } = props;

  // Create a container for the toast
  const snackbar = document.createElement("div");
  snackbar.style.position = "fixed";
  // Sits above the bottom-docked floating buttons (Quote History bottom-left,
  // AI Analyst bottom-right: 56px Fab at 24px, so 96px clears them by 16px).
  snackbar.style.bottom = "96px";
  snackbar.style.left = "24px";
  snackbar.style.zIndex = "9999";
  snackbar.style.backgroundColor =
    severity === "success"
      ? "#4caf50"
      : severity === "error"
        ? "#f44336"
        : severity === "warning"
          ? "#ff9800"
          : "#2196f3";
  snackbar.style.color = "white";
  snackbar.style.padding = "10px 20px";
  snackbar.style.borderRadius = "4px";
  snackbar.style.boxShadow = "0 2px 5px rgba(0, 0, 0, 0.2)";

  // Add title
  const titleElement = document.createElement("div");
  titleElement.style.fontWeight = "bold";
  titleElement.textContent = title;

  // Add description
  const descElement = document.createElement("div");
  // `?? null` matches the DOM's own handling: textContent treats undefined as null (empty)
  descElement.textContent = description ?? null;

  // Append elements
  snackbar.appendChild(titleElement);
  snackbar.appendChild(descElement);
  document.body.appendChild(snackbar);

  // Fade out and remove after a delay
  setTimeout(() => {
    snackbar.style.opacity = "0";
    snackbar.style.transition = "opacity 0.5s";
    setTimeout(() => {
      document.body.removeChild(snackbar);
    }, 500);
  }, 5000);
};
